/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function mobileFiltersDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            'activeFilters': '=',
            'facets': '=',
            'activeCategory': '=',
            'onSortOptionSelected': '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: mobileFilters,
        template: require('./mobileFiltersView.html')
    };
}

mobileFilters.$inject = [
    '$rootScope',
    '$window',
    'UtilService',
    'FiltersService',
    'CmsContentService',
];
function mobileFilters(
    $rootScope,
    $window,
    UtilService,
    FiltersService,
    CmsContentService
) {

    this.$onInit = () => {
        const vm = this;
        FiltersService.closeMobileFilters();

        vm.resetFilters = FiltersService.resetFilters;

        CmsContentService.retrieveCMSValue(vm, 'showSingleResultText', 'filters:show_single_result_text');
        CmsContentService.retrieveCMSValue(vm, 'showMultipleResultsText', 'filters:show_multiple_results_text');

        vm.filterResults = () => {
            vm.closeMobileFilters();
        };

        vm.closeMobileFilters = () => {
            FiltersService.filterResults();
            FiltersService.closeMobileFilters();
        };

        vm.isEnabled = shouldShow();
        angular.element($window).bind('resize', () => {
            FiltersService.lockFilters = false;
            if (vm.isEnabled && !shouldShow()) {
                vm.isEnabled = false;
                FiltersService.closeMobileFilters();
            }
            if (!vm.isEnabled && shouldShow()) {
                FiltersService.getResultsQuantity();
                vm.isEnabled = true;
            }
        });

        /**
         * @type {number|null} the quantity of the results based on the current filters
         */
        vm.resultsQuantity = null;
        FiltersService.onResultsQuantityUpdated((resultsQuantity) => {
            vm.resultsQuantity = resultsQuantity;
        });

        /**
         * Determines whether or not we should show the mobile's new filters
         *
         * @returns {boolean} Whether or not we should show the mobile's new filters
         */
        function shouldShow() {
            return UtilService.isMobile() && FiltersService.isNewFiltersEnabled;
        }
    };
}

module.exports = mobileFiltersDirective;
